// @ts-nocheck
export default {
    welcome: "Добро пожаловать",
    email_address: "Адрес электронной почты",
    email_or_phone: "Адрес электронной почты или номер телефона",
    enter_your_email: "Введите ваш адрес электронной почты",
    enter_your_email_or_phone:
        "Введите ваш адрес электронной почты или номер телефона",
    phone_placeholder: "Номер телефона",
    password: "Пароль",
    confirm_password: "Подтвердите пароль",
    log_in: "Войти",
    login: "Вход",
    forgot_password: "Забыли пароль?",
    forgot_password_title: "Забыли пароль",
    keep_me_logged_in: "Оставаться в системе",
    sign_in: "Войти",
    not_registered: "Еще не зарегистрированы?",
    create_account: "Создать аккаунт",
    sign_up: "Зарегистрироваться",
    first_name: "Имя",
    last_name: "Фамилия",
    dob_placeholder: "Дата рождения (ДД/ММ/ГГГГ)",
    submit: "Отправить",
    already_have_account: "Уже есть аккаунт?",
    why_need_dob_title: "Почему нам это нужно?",
    why_need_dob_text: `Используя этот сайт, вы заявляете, подтверждаете и соглашаетесь с тем, что вам не менее 14 лет, или если вам меньше 18 лет, но не менее 14 лет (несовершеннолетний), вы используете сайт с согласия вашего родителя или законного опекуна и получили разрешение вашего родителя или законного опекуна на использование сайта и согласие с его условиями. Если вы являетесь родителем или законным опекуном несовершеннолетнего, вы настоящим соглашаетесь связать несовершеннолетнего с этими условиями и полностью возместить и освободить компанию от ответственности, если несовершеннолетний нарушит какие-либо из этих условий. Если вам не исполнилось 14 лет, вы не можете использовать сайт в любое время или любым образом, а также отправлять какую-либо информацию компании или сайту. ПРИМЕЧАНИЕ: В некоторых случаях использование этого программного обеспечения требует, чтобы пользователи были не моложе 14 лет, не моложе 16 лет или не моложе 18 лет. Если вам отказано в регистрации после ввода даты рождения, это связано с тем, что конкретный портал, на который вы регистрируетесь, имеет одно из этих требований.`,
    go_back: "Вернуться",
    email_verification: "Подтверждение электронной почты",
    log_out: "Выйти",
    resend_email_verification: "Повторно отправить письмо для подтверждения",
    resend_text_verification: "Повторно отправить текст для подтверждения",
    send_email_verification_instead:
        "Отправить письмо для подтверждения вместо этого",
    send_text_verification_instead:
        "Отправить текст для подтверждения вместо этого",
    reset_password: "Сбросить пароль",
    accept_invite: "Принять приглашение",
    my_hep: "Мой домашний план упражнений",
    plan_created: "План создан",
    remove_plan: "Удалить план",
    open_plan: "Открыть этот план",
    remove_plan_confirm_text: "Вы уверены, что хотите удалить этот план?",
    duplicate_plan_check_text:
        "У вас уже назначен этот план. Вы уверены, что хотите переназначить этот план?",
    duplicate_plan_modal: {
        yes_text: "Да",
        no_text: "Перейти на панель управления",
    },
    translation_disclaimer: {
        title: "Отказ от ответственности за перевод",
        subtitle: "Обратите внимание, что наши переводы выполняются с помощью программного обеспечения искусственного интеллекта, точность которого составляет примерно 98%. Чтобы обеспечить четкое и точное общение, мы советуем запрашивать разъяснения по любым переводам, которые кажутся неясными или неправильными. Также рекомендуется использовать простой язык и избегать сленга, чтобы свести к минимуму возможные недоразумения.",
        accept_button_text: "Я ПОНИМАЮ И СОГЛАШАЮСЬ ИСПОЛЬЗОВАТЬ НА СВОЙ СОБСТВЕННЫЙ РИСК",
    },
    provider: "Поставщик",
    self_help_text: "Самопомощь",
    show_all: "Показать все",
    no_record: "Записей не найдено",
    no_heps: "Здесь вы найдете свои планы восстановления, которые были созданы после того, как они были назначены вам вашим поставщиком медицинских услуг или назначены вами самостоятельно с помощью любого из наших инструментов самопомощи, которые могут быть вам доступны. В настоящее время вам ничего не назначено.",
    what_to_do: "Что делать",
    hold_time: "Время удержания",
    day_per_week: "Дней в неделю",
    equipment: "Оборудование",
    sets: "Подходы",
    reps: "Повторения",
    weight: "Вес",
    in_pounds: "В фунтах",
    time_per_day: "Время в день",
    starting_position: "Начальная позиция",
    description: "Описание",
    what_you_feel: "Что вы должны чувствовать",
    too_easy: "Слишком легко",
    too_hard: "Слишком сложно",
    just_right: "В самый раз",
    exercise: "Упражнение",
    education: "Образование",
    back_to_list: "Вернуться к списку",
    about_this_exercise: "Что вы думаете об этом упражнении?",
    attachement: "Вложение",
    exercise_completed: "Отметить упражнение как выполненное",
    no_details: "Нет доступных деталей.",
    hep_details: {
        hard_exercise_modal: {
            title: "Необходима корректировка упражнения.",
            description_line1:
                "Это самое легкое упражнение в этой стратегии, поэтому мы не можем предложить более легкое на данный момент.",
            description_line2:
                "Если какое-либо упражнение кажется вам слишком сложным, вызывает беспокойство или вы не уверены, что делать дальше, немедленно прекратите и проконсультируйтесь с медицинским специалистом или вашим назначенным поставщиком, если этот план восстановления был предписан.",
            btn_text: "Я прочитал и понимаю эти рекомендации",
        },
    },
    flash_card: {
        yes_text: "Да",
        no_text: "Нет",
    },
    complete_strategy_modal: {
        title: "Поздравляем!",
        description: "Вы завершили этот набор упражнений.",
        btn_text: "Перейти к списку HEP",
    },
    talk_to_expert: {
        title: "Поговорите с экспертом",
        breadcrumb: "Поговорите с экспертом!",
        book_now: "Забронировать сейчас",
        powered_by: "на базе",
    },
    find_clinic: {
        title: "Найти клинику",
        search: "Введите местоположение",
        breadcrumb: "Найти клинику",
        back_title: "Местоположения",
        result_text: "Результаты поиска",
        pagination_label: "Показать:",
        pagination_text: "Записи",
        toggle_list_map_label: "Просмотр:",
        list_text: "Список",
        map_text: "Карта",
        print_text: "печать",
        not_found: "Клиники не найдены",
    },
    messages: {
        title: "Сообщения",
        new_message: "Новое сообщение",
        welcome: "Добро пожаловать",
        you_are_signed_in_as: "Вы вошли как",
        hi: "Привет",
        you_are_disconnected: "Вы в данный момент отключены от интернета.",
        practice: "Практика",
        provider: "Поставщик",
        could_not_send_msg: "Не удалось отправить сообщение.",
        some_files_removed:
            "Некоторые файлы размером более 100 МБ были удалены.",
        say_hello: "Скажите привет",
        hello_text: "Привет!",
        start_conversation: "Начните новый разговор",
        send: "Отправить",
        textbox_placeholder: "Начните печатать...",
        search_placeholder: "Поиск...",
        no_provider: "Поставщик не назначен.",
        no_active_chat:
            "У вас нет активных чатов. Начните новый чат, нажав кнопку нового сообщения.",
    },
    header_messages: {
        title: "Сообщения",
        view_all: "ПОСМОТРЕТЬ ВСЕ",
        no_messages: "Пока нет сообщений",
    },
    support: {
        title: "Поддержка",
        tech_support_email: "Электронная почта технической поддержки",
        other_question: "Другие вопросы",
        section1_title:
            "Клиническая поддержка (вопросы, связанные с медициной)",
        section1_description:
            "В случае угрожающей жизни или медицинской чрезвычайной ситуации немедленно наберите 911. Для неэкстренных медицинских вопросов, пожалуйста, свяжитесь с",
        section2_title:
            "Техническая поддержка (вопросы, связанные с программным обеспечением)",
        section2_description:
            "Наша техническая поддержка доступна с 7:00 до 16:00 по тихоокеанскому времени, с понедельника по пятницу, за исключением основных праздников. Любые заявки, сделанные вне этих часов, будут рассмотрены на следующий рабочий день.",
        tech_support_email_address: "support@everflexplus.com",
    },
    injury_prevention_plan: {
        title: "План предотвращения травм",
        heading: "Хотите опередить травмы? Попробуйте план профилактики!",
        description:
            "У нас есть упражнения, которые помогут предотвратить боль и травмы, а также укрепить те области, которые нужно развить для повышения эффективности.",
        workplace_label: "Планы для рабочего места",
        sport_label: "Спортивные планы",
        speciality_label: "Специальные планы",
        generalized_label: "Общие планы",
        start_plan: "Начать план",
    },
    footer: {
        copyright_text: "Everflex Plus Health | Все права защищены",
        pat_no_text:
            "Эти продукты защищены патентом № US 11,587,687 и другими заявками на патенты.",
        about: "О нас",
        security_statement: "Заявление о безопасности",
        privacy_policy: "Политика конфиденциальности",
        terms_conditions: "Условия и положения",
        contact: "Контакты",
        support: "Поддержка",
        faqs: "Часто задаваемые вопросы",
        patent_information_text: "Информация о патентах",
    },
    my_profile: {
        head_title_text: "Профиль",
        my_account_text: "Мой аккаунт",
        tab: {
            account_information_text: "Информация об аккаунте",
            communication_preferences_text: "Настройки связи",
            change_password_text: "Изменить пароль",
        },
        account_information_form: {
            page_heading_text: "Информация об аккаунте",
            first_name_field: {
                label_text: "Имя",
                placeholder_text: "Введите имя",
            },
            last_name_field: {
                label_text: "Фамилия",
                placeholder_text: "Введите фамилию",
            },
            dob_field: {
                label_text: "Дата рождения",
                placeholder_text: "Дата рождения (ММ/ДД/ГГГГ)",
            },
            email_field: {
                label_text: "Электронная почта/Имя пользователя",
                placeholder_text: "Введите электронную почту/Имя пользователя",
            },
            phone_number_field: {
                label_text: "Номер телефона",
                placeholder_text: "Введите номер телефона",
            },
            otp_modal: {},
            unverified_email_text:
                "Ваша электронная почта/имя пользователя не подтверждены.",
            unverified_email_btn_text:
                "Нажмите здесь, чтобы повторно отправить письмо для подтверждения.",
            verification_link_sent_text:
                "Новая ссылка для подтверждения отправлена на ваш адрес электронной почты.",
            verification_link_not_sent:
                "Пожалуйста, укажите адрес электронной почты для его подтверждения.",
            submit_btn_text: "Отправить",
        },
        change_password_form: {
            page_heading_text: "Информация для входа",
            current_password_field: {
                label_text: "Ваш текущий пароль",
                placeholder_text: "Введите текущий пароль",
            },
            new_password_field: {
                label_text: "Новый пароль",
                placeholder_text: "Введите новый пароль",
            },
            confirm_password_field: {
                label_text: "Подтвердите пароль",
                placeholder_text: "Введите пароль еще раз",
            },
            submit_btn_text: "Отправить",
        },
        communication_preference_form: {
            page_heading_text: "Настройки связи",
            table_headings: {
                setting_text: "Настройка",
                opt_in_text: "Подписаться",
                opt_out_text: "Отписаться",
            },
            table_body: {
                email_notification_text: "Уведомления по электронной почте",
                sms_notification_text: "Уведомления по SMS",
            },
            submit_btn_text: "Отправить",
        },
    },
    password_requirement_text:
        "Пароль должен содержать не менее 8 символов, включая заглавные и строчные буквы, цифры и символы.",
    language: {
        could_not_update: "Не удалось обновить язык.",
    },
    error_page: {
        go_back_text: "Вернуться на главную",
        403: {
            title: "403: Доступ запрещен",
            description: "Извините, у вас нет доступа к этой странице.",
        },
        404: {
            title: "404: Страница не найдена",
            description: "Извините, страница, которую вы ищете, не найдена.",
        },
        500: {
            title: "500: Ошибка сервера",
            description: "Упс, что-то пошло не так на наших серверах.",
        },
        503: {
            title: "503: Сервис недоступен",
            description:
                "Извините, мы проводим техническое обслуживание. Пожалуйста, зайдите позже.",
        },
    },
    identify_injury: {
        select: {
            front: "Передняя часть",
            back: "Задняя часть",
            heading: "Моя травма",
            page_title: "Моя травма",
            okay: "ОК",
            tell_me: "расскажите мне",
            about_pain: "о вашей боли",
            answer_question:
                "Ответьте на несколько вопросов и получите персонализированную серию упражнений, основанных на доказательствах и подобранных физиотерапевтами, чтобы помочь вам мягко облегчить боль при 23 наиболее часто встречающихся заболеваниях. Если вы не подходите под шаблон травмы, вы можете воспользоваться самопомощью с нашими общими планами, найти клинику физиотерапии рядом с вами или посетить живого поставщика онлайн.",
            select_body_part: "Выберите одну часть тела, где у вас проблемы:",
            next: "Далее",
            body_part_not_found: "Часть тела не найдена.",
        },
        show: {
            no_question_found: "Вопрос не найден",
            next: "Далее",
            heading: "Определить мою травму",
            page_title: "Определить мою травму",
            play_video_info:
                "Посмотрите видео, чтобы услышать более подробное объяснение вопроса от лицензированного физиотерапевта.",
        },
        body_part: {
            heading: (bodyPart) => `Изучите оценку ${bodyPart}`,
            sub_heading: (currentBodyPart, newBodyPart) =>
                `Не нашли облегчения от упражнений для ${currentBodyPart}? Перенаправьте, чтобы оценить и устранить связанные проблемы ${newBodyPart}.`,
            explore_plans: "Изучить планы",
        },
        fallout: {
            heading:
                "На основании предоставленной вами информации вы не попали в один из наших шаблонов травм.",
            sub_heading:
                "Рекомендуется поговорить с лицензированным физиотерапевтом, чтобы обеспечить наилучший уход. Мы предлагаем следующие варианты, чтобы удовлетворить ваши потребности:",
            talk_to_expert: "Поговорите с экспертом",
            find_clinic: "Найти клинику",
        },
        generalized: {
            heading: "Изучите общие планы",
            sub_heading:
                "Не нашли то, что нужно? Перенаправьте на более широкий спектр вариантов для управления болью или улучшения упражнений.",
            explore_plans: "Изучить планы",
            not_ready_to_speak_heading: "Не готовы поговорить с экспертом? Ознакомьтесь с нашими общими планами.",
            not_ready_to_speak_sub_heading: "Нажмите ниже, чтобы увидеть дополнительные варианты, которые помогут справиться с болью или травмой.",
        },
        hep: {
            heading: "Отличная работа 🎉",
            sub_heading:
                "Ваши ответы успешно сопоставлены с установленным шаблоном травмы. Мы назначили вам план восстановления, соответствующий этим результатам.",
            get_started: "начать",
        },
        all_body_parts: {
            neck: "Шея",
            shoulder: "Плечо",
            elbow_hand: "Локоть и кисть",
            elbow_arm: "Локоть/Рука",
            wrist_hand: "Кисть/Рука",
            back: "Спина",
            hip: "Бедро",
            knee: "Колено",
            knee_leg: "Колено и нога",
            ankle_foot: "Лодыжка и стопа",
        },
        something_went_wrong_self_help_logs:
            "Произошла ошибка при сохранении вашего журнала самопомощи.",
    },
    cms_pages: {
        about: {
            breadcrumb_text: "О нас",
            head_text: "О нас",
            title_text: "О нас",
        },
        security_statement: {
            breadcrumb_text: "Заявление о безопасности",
            head_text: "Заявление о безопасности",
            title_text: "Заявление о безопасности",
        },
        privacy: {
            breadcrumb_text: "Политика конфиденциальности",
            head_text: "Политика конфиденциальности",
            title_text: "Политика конфиденциальности",
        },
        terms: {
            breadcrumb_text: "Условия и положения",
            head_text: "Условия и положения",
            title_text: "Условия и положения",
        },
        faq: {
            breadcrumb_text: "Часто задаваемые вопросы",
            head_text: "Часто задаваемые вопросы",
            title_text: "Часто задаваемые вопросы",
        },
        patent: {
            breadcrumb_text: "Информация о патентах",
            head_text: "Информация о патентах",
            title_text: "Информация о патентах",
        },
        no_data_text: "Данные не найдены!",
    },
    accept_terms: {
        i_agree_text: "Я согласен с условиями, изложенными выше.",
        yes_btn_text: "Да",
        no_btn_text: "Нет",
        terms_and_conditions_text: "Условия и положения",
        terms_updated: "Наши положения и условия изменились с тех пор, как вы их приняли в последний раз",
    },
    hep_restart: {
        check_in: "Время регистрации",
        completed: "Ваш план завершен!",
        hey: "Привет,",
        complete_plan_desc: `Мы рады отпраздновать ваш потрясающий прогресс за последние 21 день!`,
        take_a_moment: `Найдите минутку, чтобы подумать о том, как вы себя чувствуете.`,
        feeling_better: `Чувствуете себя лучше? Отлично!`,
        current_plan_desc: `Вы можете нажать кнопку ЗАВЕРШИТЬ МОЙ ТЕКУЩИЙ ПЛАН ниже. За ваше здоровье!`,
        resume_plan_desc: `Чтобы продолжить свой план и сохранить импульс, нажмите кнопку ВОЗОБНОВИТЬ МОЙ ПЛАН ниже.`,
        clinic_desc: `Если вы не заметили большого прогресса или вам нужна дополнительная поддержка, мы вас поддержим! Ничего страшного, если нужно сделать паузу. Мы рекомендуем поговорить с медицинским специалистом, который может предоставить персонализированные рекомендации.`,
        top_priority: `Ваше благополучие - наш главный приоритет.`,
        support_you: `Мы здесь, чтобы поддерживать вас на каждом шагу.`,
        complete_plan_btn: `Завершить мой текущий план`,
        resume_plan_btn: `Возобновить мой текущий план`,
        clinic_btn: "Найти медицинского специалиста рядом с вами",
        keep_moment: "Хотите сохранить импульс?",
        is_completed_resume_plan: `Нажмите кнопку ВОЗОБНОВИТЬ МОЙ ПЛАН ниже.`,
    },
    header_module: {
        notification_section: {
            popup_heading: "Уведомления",
            view_all_text: "Посмотреть все",
            no_data_text: "Нет уведомлений для отображения.",
        },
        select_preferred_language: "Выберите предпочитаемый язык",
        my_account: "Мой аккаунт",
        sign_out: "Выйти",
        logout_go_back: "Выйти/Вернуться",
    },
    notification_center: {
        list: {
            page_title: "Список уведомлений",
            page_heading: "Все уведомления",
            no_record: "Уведомления не найдены",
        },
        show: {
            page_title: "Просмотр уведомлений",
            page_heading: "Детали уведомления",
        },
        breadcrumb: {
            notification_text: "Все уведомления",
        },
        action: {
            view: "Просмотр",
            delete: "Удалить",
            delete_confirm: "Вы уверены, что хотите удалить это уведомление?",
        },
    },
    general_error: "Что-то пошло не так. Пожалуйста, попробуйте позже.",
    start_screen: {
        title: "Введите ваш email или номер телефона",
        heading: "Введите ваш email или номер телефона",
        email_placeholder: "Введите ваш email или номер телефона",
        btn_text: "Далее",
        account_disabled_error:
            "Ваш аккаунт отключен, пожалуйста, свяжитесь с поддержкой.",
        invite_sent:
            "Приглашение отправлено успешно, пожалуйста, проверьте вашу почту.",
        invite_sent_by_text: "Приглашение отправлено по SMS",
        send_invite_by_text: "Отправить приглашение по SMS вместо этого",
        account_not_found: "Аккаунт не найден!",
        choose_account: "Выберите вашу клинику для продолжения!",
    },
    invite_modal: {
        heading: "Мы нашли ваш аккаунт",
        sub_heading:
            "Ваш аккаунт был создан, но процесс регистрации не завершен. Пожалуйста, проверьте вашу почту для получения приглашения для завершения регистрации, или запросите новое приглашение, если необходимо.",
        btn_text: "Повторно отправить приглашение по email",
        btn_text_sms: "Повторно отправить приглашение по SMS",
    },
    preference_modal: {
        acceptance_text: (clinicName) =>
            `Я разрешаю, чтобы следующие сообщения от ${clinicName} доставлялись мне предоставленными электронными средствами. Я понимаю, что некоторые формы электронных сообщений могут быть небезопасными, создавая риск неправильного раскрытия неавторизованным лицам.`,
        acceptance_text_2: `Я готов принять этот риск и не буду держать практику ответственным, если такой инцидент произойдет.`,
        sms_notification_text: `Уведомления по SMS - когда это уместно для вашего плана восстановления и назначено вашим поставщиком`,
        email_notification_text: `Уведомления по электронной почте (важные обновления, напоминания о другой информации, связанной с медициной, и иногда маркетинговые сообщения)`,
        marketing_text: "Маркетинговые письма - получайте образовательный контент, информацию о сервисах или обновлениях продуктов, соответствующих вашим интересам и активности в портале. ПРИМЕЧАНИЕ: Мы НИКОГДА не продаем вашу информацию третьим сторонам.",
        clinical_text: "Клинические письма - получайте важные обновления и информацию, касающуюся вашего лечения и пути к оздоровлению.",
        system_text: "Системные уведомления по электронной почте - будьте в курсе важных обновлений системы и предупреждений о безопасности.",
        system: {
            header: "Системные уведомления по электронной почте",
            subtext: "Будьте в курсе важных обновлений системы и предупреждений о безопасности.",
        },
        clinical: {
            header: "Клинические письма",
            subtext: "Получайте важные обновления и информацию, касающуюся вашего лечения и пути к оздоровлению.",
        },
        marketing: {
            header: "Маркетинговые письма",
            subtext: "Получайте образовательный контент, информацию о сервисах или обновлениях продуктов, соответствующих вашим интересам и активности в портале. ПРИМЕЧАНИЕ: Мы НИКОГДА не продаем вашу информацию третьим сторонам.",
        },
        sms: {
            text: "Text (SMS) Notifications",
        },
        accept_btn_text: "Принять",
        submit_btn_text: "Отправить",
        enter_phone: "ВВЕДИТЕ ВАШ НОМЕР МОБИЛЬНОГО ТЕЛЕФОНА",
        default_timezone_text: (defaultTimezone) =>
            `Мы отправим вам напоминание по SMS о выполнении упражнений в 18:00 по местному времени. Похоже, вы находитесь в часовом поясе ${defaultTimezone}, верно?`,
        timezone_required: "Требуется часовой пояс.",
        saved: "Настройки сохранены.",
        no_btn_text: "Нет",
        yes_btn_text: "Да",
        select_timezone: "Выберите часовой пояс",
        select_your_timezone: "Выберите ваш часовой пояс",
    },
    set_new_password: {
        heading: "УСТАНОВИТЕ НОВЫЙ ПАРОЛЬ",
        sub_heading:
            "Для повышения безопасности введите ваш текущий пароль, предоставленный администратором, а затем установите новый пароль.",
        current_password_label: "Текущий пароль",
        current_password_placeholder: "Введите текущий пароль",
        new_password_label: "Новый пароль",
        new_password_placeholder: "Введите новый пароль",
        confirm_password_label: "Подтвердите новый пароль",
        confirm_password_placeholder: "Подтвердите пароль",
        save_btn_text: "Сохранить пароль",
    },
    hep_status: {
        completed: "Завершено",
        self_assigned: "Самостоятельно назначено",
        independent: "Независимая домашняя программа",
    },
    level: "Уровень",
    sec: "Сек",
    days: "Дни",
    repetitions: "Повторения",
    lbs: "Фунты",
    time: "Время",
    allLanguages: {
        en: "Английский",
        es: "Испанский",
        fr: "Французский",
        zh: "Китайский (упрощенный)",
        "zh-TW": "Китайский (традиционный)",
        tl: "Тагальский",
        vi: "Вьетнамский",
        ar: "Арабский",
        ko: "Корейский",
        ru: "Русский",
        hi: "Хинди",
        sw: "Суахили",
    },
    outcomes: {
        next: "Далее",
        back: "Назад",
        continue: "Продолжить",
        finish: "Завершить",
        response_title: "Спасибо за ваш отзыв.",
        groc: {
            title: "Оцените свой прогресс со временем",
            subtitle: "Оцените свое состояние по сравнению с вашим ПЕРВОНАЧАЛЬНЫМ визитом или началом лечения. Выберите вариант, который лучше всего описывает общие изменения, произошедшие с того времени. Учитывайте как положительные, так и отрицательные изменения, включая улучшения и ухудшения вашего состояния.",
            text_neg_7: "Гораздо хуже",
            text_neg_4: "Хуже",
            text_0: "Без изменений",
            text_4: "Лучше",
            text_7: "Гораздо лучше",
        },
        pass: {
            subtitle: "Учитывая уровень ваших симптомов, трудности с движением или активностью, а также то, как ваше состояние влияет на повседневную жизнь в целом, считаете ли вы своё текущее состояние приемлемым, если ваш прогресс останется на том же уровне?",
            yes: "Да",
            no: "Нет",
        },
        psfs: {
            title: "Оцените сложности с повседневной активностью",
            subtitle: "Пожалуйста, укажите 3 важных вида деятельности, которые вы не можете выполнять или испытываете затруднения из-за вашего состояния. Для каждой деятельности укажите оценку текущего уровня сложности на сегодняшний день.",
            repeat_subtitle: "Подумайте о своем состоянии по сравнению с вашим ПЕРВЫМ визитом или началом лечения. Для каждого вида деятельности, пожалуйста, укажите балл активности для вашего текущего уровня сложности на сегодняшний день.",
            text_0: "Не могу выполнить",
            text_10: "Могу выполнять так же, как до травмы",
            activity: "Деятельность",
            text_0: "Не могу выполнить",
            text_10: "Могу выполнять так же, как до травмы",
        }
    }    
};
